module.exports = __webpack_public_path__ + "static/media/ic_broadband.e70b8bd9.png";